import request from 'utils/axios';
import { Method } from 'axios';
import { httpVerbs, AGENCY_MANAGEMENT_BASE_URL } from 'configs';
import { IBannerListResponse, IBannerTableResponse, ICreateBannerResponse } from './types';
import { IDeleteRecordResponse } from 'interfaces/general';

const SEGMENT = `${AGENCY_MANAGEMENT_BASE_URL}/api/v1/banners`;

export const getBannersByAgencyId = async (agencyId: number | string): Promise<IBannerListResponse> => {
  const url = `${SEGMENT}/agency/${agencyId}`;
  const response = await request({
    url,
    method: httpVerbs.GET as Method,
  });

  if (Array.isArray(response)) {
    return response;
  }
  return response.data;
};

export const createBanner = async (formData: FormData): Promise<ICreateBannerResponse> => {
  const url = SEGMENT;
  const { data } = await request({
    url,
    method: httpVerbs.POST as Method,
    data: formData,
    customHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const updateBanner = async (id: number | string, formData: FormData): Promise<ICreateBannerResponse> => {
  const url = `${SEGMENT}/${id}`;
  const { data } = await request({
    url,
    method: httpVerbs.PUT as Method,
    data: formData,
    customHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getSingleBanner = async (id: number | string) => {
  const url = `${SEGMENT}/${id}`;
  const response = await request({
    url,
    method: httpVerbs.GET as Method,
  });

  return response;
};

export const updateBannerTranslation = async (
  id: number | string,
  formData: FormData,
): Promise<ICreateBannerResponse> => {
  const url = `${SEGMENT}/${id}/translations`;
  const { data } = await request({
    url,
    method: httpVerbs.POST as Method,
    data: formData,
    customHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const updateBannerTranslationById = async (
  id: number | string,
  formData: FormData,
): Promise<ICreateBannerResponse> => {
  const url = `${SEGMENT}/translations/${id}`;
  const { data } = await request({
    url,
    method: httpVerbs.PUT as Method,
    data: formData,
    customHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const deleteBannerTranslation = async (translationId: number | string): Promise<IDeleteRecordResponse> => {
  const url = `${SEGMENT}/translations/${translationId}`;
  const { data } = await request({
    url,
    method: httpVerbs.DELETE as Method,
  });
  return data;
};

export const deleteBanner = async (id: number | string): Promise<IDeleteRecordResponse> => {
  const url = `${SEGMENT}/${id}`;
  const { data } = await request({
    url,
    method: httpVerbs.DELETE as Method,
  });
  return data;
};

export const searchBanners = async (
  id: number | string,
  params: {
    page: number;
    size: number;
  },
): Promise<IBannerTableResponse> => {
  const url = `${SEGMENT}/${id}/search`;
  const { data } = await request({
    url,
    method: httpVerbs.POST as Method,
    data: params,
  });
  return data;
};
